module.exports = __webpack_public_path__ + "img/table.6c8d5ce4.png";